/** @jsx jsx */

import { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import ClickAndReveals from './ClickAndReveals';
import ClickAndReveal from './ClickAndReveal';
import ClickAndRevealContent from './ClickAndRevealContent';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import { interactionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import EditableBtn from 'components/lib/EditableBtn';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import shouldUpdate from 'services/shouldUpdate';
import imagePlaceholder from 'assets/CC_AW 980 x 685px.png'; // Rectangle 2.png';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'click-and-reveal-text' }} />
  ),
  ClickAndReveals,
  ClickAndReveal,
  Feedback: ({ children, ...props }) => children,
  Content: ClickAndRevealContent,
  ColumnRowA: ({ children, ...props }) => children,
  ColumnRowB: ({ children, ...props }) => children,

  Image: ({ children, ...props }) => {
    const mediaParent = getMediaParent(props.id);

    return mediaParent ? (
      <Image
        {...{
          ...props,
          placeholder: imagePlaceholder,
          editWrapperType: props.hasOwnProperty('editWrapperType')
            ? props.editWrapperType
            : 1,
          editWrapperSize: '65%',
          editWrapperUseIcon: false,
        }}
      />
    ) : (
      <Image {...{ ...props, usePlaceholderValue: true }} />
    );
  },
  Video,
  Audio,
  Transcript: () => null,
  SVG: ({ children, ...props }) => (
    <SVG {...{ ...props, editWrapperType: 1 }} />
  ),
  Embed: () => null,
  Media,
  PDF: () => null,
  OpenPDF: () => null,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: continueBtn,
  EditableButton: EditableBtn,
  ...IELayout(interactionContext),
};

const ClickAndRevealDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default ClickAndRevealDisplay;
